import React, { useState } from 'react';
import { V } from '../utils/theme';
import { Btn } from './ui';
import { REPORT_REASONS, reportUser } from '../utils/accountActions';
import { accountRequest, readAccountSession } from '../utils/accountSession';

export function ReportUser({target, name}) {
  const [open,setOpen]=useState(false);
  const [reason,setReason]=useState('harassment');
  const [detail,setDetail]=useState('');
  const [busy,setBusy]=useState(false);
  const [message,setMessage]=useState('');
  const [sent,setSent]=useState(false);
  const send=async()=>{
    if(busy)return;setBusy(true);setMessage('');
    const result=await reportUser({target,reason,detail},{readSession:readAccountSession,
      request:(body,session)=>accountRequest('/api/social?route=report',body,session)});
    setBusy(false);setSent(result.ok);setMessage(result.ok?'Report sent. Thank you.':result.error);
  };
  return <div style={{fontSize:12}}>
    {!open?<Btn v="secondary" full onClick={()=>setOpen(true)}>Report {name}</Btn>:<div style={{display:'grid',gap:10,padding:12,border:`1px solid ${V.cardBorder}`,borderRadius:10}}>
      <strong>Report {name}</strong>
      {!sent&&<>
        <label style={{display:'grid',gap:4}}>Reason<select disabled={busy} value={reason} onChange={e=>setReason(e.target.value)} style={{padding:12,background:V.card,color:V.text}}>{REPORT_REASONS.map(([key,label])=><option key={key} value={key}>{label}</option>)}</select></label>
        <label style={{display:'grid',gap:4}}>Details (optional)<textarea disabled={busy} maxLength={1000} rows={3} value={detail} onChange={e=>setDetail(e.target.value)} style={{padding:10,background:V.card,color:V.text}}/></label>
        <div style={{color:V.text3}}>Reports are sent for review. To prevent contact, use Block separately.</div>
        <Btn disabled={busy} onClick={send}>{busy?'Sending…':'Send report'}</Btn>
      </>}
      {message&&<div role={sent?'status':'alert'} style={{color:sent?V.accent:V.danger}}>{message}</div>}
      <Btn v="secondary" disabled={busy} onClick={()=>{setOpen(false);setMessage('');setSent(false);setDetail('');}}>Close report</Btn>
    </div>}
  </div>;
}
